export default {
    to: "/dashboard/waas/transaction/check-status",
    order: 3,
    icon: "mdi-state-machine",
    title: "Check Transaction Status",
    disabled: false,
    value: 0,
}
